<script>   
  import { fade } from "svelte/transition";  
  import { redirect } from "../pager";

    import Navigationbar from "../components/Navigationbar.svelte";
    import { session } from "../components/js/notif.js";
    let settings;
    session.subscribe((value) => {
      settings = value;
    });
    
  
    //scroll to top every page load
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  
    //navigation
    let navigation = [];
     $: if (settings.loggedin == true) {
      if (settings.data.pen != undefined) {
        navigation["message"] = settings.data.pen.nm;
      } else {
        navigation["message"] = "Selamat Datang";
      }
    } else {
      navigation["message"] = "Selamat Datang";
    }
   
  
    let query = "";
  function handleSearch() {
    query = query.replace(/\s+/g, "+"); 
    if (query != "") { 
        redirect("/cari/q/" + query); 
    } else {
      redirect("/belanja/");
    }
  }
 
	import { onMount } from 'svelte'
	let searchInput
	// this works here, but not in Sapper:
	onMount(() => searchInput.focus())
  </script>
  <svelte:head>
  <title>Pencarian Ke Dekatan</title>
  </svelte:head>
  <Navigationbar
    backbtn="true"
    title="Pencarian"
    message={navigation['message']} />
  <main transition:fade class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0">
     
    <div class="w-full px-2 mx-auto">
      <div class="w-full p-6 bg-white rounded-lg shadow-lg"><div class="my-2">
        <h2 class="text-3xl">Pencarian</h2>
        <p class="text-gray-500">Ketiklah produk yang kamu inginkan pada kolom dibawah ini, lalu klik tombol pencarian</p> 
      
        <form
        action="/shop/search"
        class="relative flex items-stretch justify-center order-last w-full px-2 py-2 mt-2 mb-5 rounded-lg shadow-md pointer-events-none lg:w-1/2 md:w-1/2 search lg:order-none"
        on:submit|preventDefault={handleSearch}>
        <input bind:this={searchInput}
          id="searchfilter"
          class="w-full p-3 py-2 pr-12 text-xs font-light bg-white border border-gray-200 rounded shadow outline-none pointer-events-auto md:focus:border-blue-600"
          type="text"
          name="q"
          autocomplete="off"
          bind:value={query}
          placeholder="Cari nama produk..." />
          {#if query.length>0}
        <label for="searchfilter" on:click={()=>query=""}
          class="absolute top-0 bottom-0 right-0 flex items-center justify-center flex-grow h-full pr-4 my-auto mr-10 pointer-events-auto clear">
          <img src="./assets/svg/close.svg" alt="clear">
        </label> 
        {:else}
        <label for="searchfilter" on:click={()=>query=""}
          class="absolute top-0 bottom-0 right-0 flex items-center justify-center flex-grow invisible h-full pr-4 my-auto mr-10 pointer-events-auto clear">
          <img src="./assets/svg/close.svg" alt="clear">
        </label> 
        {/if} 
         
        <button
          aria-label="Search"
          type="submit"
          class="absolute top-0 bottom-0 right-0 flex items-center justify-center flex-grow h-auto px-3 pr-5 my-2 border-l border-gray-400 pointer-events-auto md:border-l-0 focus:bg-gray-500 focus:outline-none">
          <img src="./assets/svg/search.svg" alt="search" />
        </button>
      </form>
      </div> </div>
    </div>
  </main>
  